module.exports = __webpack_public_path__ + "static/media/APOLLO PHONOSTAGE.3742743c.png";